export default "__VITE_ASSET__CFfJkvfK__"